var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg360 = function Svg360(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.563,
    cy: 10.996,
    r: 9.9,
    stroke: "#000",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.462 10.496c0 1.016-.885 2.114-2.733 2.994-1.803.858-4.336 1.406-7.166 1.406-2.831 0-5.364-.548-7.167-1.406-1.848-.88-2.733-1.978-2.733-2.994 0-1.015.885-2.114 2.733-2.994 1.803-.858 4.336-1.406 7.167-1.406 2.83 0 5.363.548 7.166 1.406 1.848.88 2.733 1.979 2.733 2.994Z",
    stroke: "#000",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.463 10.996c0 2.823-.601 5.348-1.543 7.146-.957 1.827-2.174 2.754-3.357 2.754-1.184 0-2.401-.927-3.358-2.754-.942-1.798-1.543-4.323-1.543-7.146 0-2.822.601-5.348 1.543-7.146.957-1.827 2.174-2.754 3.357-2.754 1.184 0 2.401.927 3.358 2.754.942 1.798 1.543 4.324 1.543 7.146Z",
    stroke: "#000",
    strokeWidth: 1.2
  })));
};
export default Svg360;